import { type FormConfig, type SelectOption } from '@acme/foundation';

export const currencyFormConfig = (
  includeUnchangedFields: boolean = true,
  currencyTypeOptions: SelectOption[]
): FormConfig => ({
  id: 'add-currency-form',
  includeUnchangedFields,
  controls: [
    {
      id: 'code',
      label: 'Сокращенное наименование валюты',
      type: 'text',
      read: (ctx: any) => ctx?.code || '',
      write: { path: 'code' },
      props: {
        placeholder: 'Напишите сокращенное наименование',
      },
    },
    {
      id: 'type',
      label: 'Тип валюты',
      type: 'select',
      read: (ctx: any) => ctx?.type || '',
      write: { path: 'type' },
      props: {
        placeholder: 'Выберите тип валюты',
      },
      options: {
        source: currencyTypeOptions,
      },
    },
    {
      id: 'name',
      label: 'Полное наименование валюты',
      type: 'textarea',
      read: (ctx: any) => ctx?.name || '',
      write: { path: 'name' },
      props: {
        placeholder: 'Напишите полное наименование',
      },
    },
  ],
});
